module.exports = __webpack_public_path__ + "img/vegetable-radicchio-350x184.82c5c639.jpg";